import { NgClass } from "@angular/common";
import { Component } from "@angular/core";
import { INotification, NotificationType } from "@apiserver-rest/ponder-data-client-base";
import { NotificationService } from "@ponder-core/notifications/notification.service";
import { SvgIconComponent } from "@ponder-shared/components/svg-icon.component";
import { SvgIcon } from "@ponder-shared/utils/svgIcons";

@Component({
    selector: "global-notifications",
    imports: [NgClass, SvgIconComponent],
    templateUrl: "./global-notifications.component.html"
})
export class GlobalNotificationsComponent {
    public readonly svgIcon: SvgIcon = SvgIcon.Close;
    public globalNotifications: INotification[] = [];

    constructor(private notifications: NotificationService) {
        
    }

    public ngOnInit(): void {
        this.notifications.getNotifications().then((notifications: INotification[]) => {
            this.globalNotifications = notifications.filter(n => n.type == NotificationType.Global);
        });
    }

    public onCloseNotification(notification: INotification): void {
        var index = this.globalNotifications.findIndex(n => {
            return n.id == notification.id;
        });

        if (index >= 0) {
            this.notifications.markNotificationRead(notification.id);
            this.globalNotifications.splice(index, 1);
        }
    }
}